import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  translationConstants,
  roles,
  Directions,
  sportConstantsReversed,
  levelEnumReversed,
  proficiencyLevelEnumReversed,
  boatTypeEnumReversed,
} from "../../../../../constants";
import { useSelector } from "react-redux";
import { Col, Form } from "react-bootstrap";
import FreelanceAddonModal from "../../../../../shared/components/Modals/FreelanceAddonModal";
import editIcon from "../../../../../assets/images/icon/pencil-edit.svg";
import CertificateDetailRow from "./CertificateDetailRow";

const GeneralTabSideView = (props) => {
  const { t } = useTranslation();

  const [isFreelanceModal, setFreelanceModal] = useState(false);

  const profileData = useSelector((state) => state.ProfileReducer.profileData);
  const freelanceData = useSelector(
    (state) => state.InstructorReducer.freelanceInstructorSportsDetail
  );
  const instructorData = useSelector(
    (state) => state.InstructorReducer.instructorCenterDetail
  );
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });

  const getSportNames = (sportIds) => {
    return sportIds?.map((id) => (
      <div className="font-14">
        {t(translationConstants[sportConstantsReversed[id]])}
      </div>
    ));
  };

  const certificatesData = props?.certificates;
  const sports = certificatesData?.map((cert) => cert.sportId);

  const [selectedSportId, setSelectedSportId] = useState(sports[0] || "");

  // Handle dropdown selection change
  const handleSportChange = (event) => {
    setSelectedSportId(event.target.value);
  };

  // Filter certificates based on selected sport
  const filteredCertificates = certificatesData?.filter(
    (cert) => cert.sportId === parseInt(selectedSportId)
  );

  return (
    <div className="">
      {certificatesData && (
        <Form.Select
          id="sportId"
          className="general-side-tab-form-select custom-select-icon mb-1 profile-sidebar-margin"
          onChange={handleSportChange}
          value={selectedSportId}
        >
          {sports?.map((sportId) => (
            <option key={sportId} value={sportId}>
              {t(translationConstants[sportConstantsReversed[sportId]])}
            </option>
          ))}
        </Form.Select>
      )}

      {filteredCertificates?.map((document, docIndex) => {
        return document?.boatTypeLevels?.map((detail, detailIndex) => {
          const { boatTypeId, levelId, proficiencyLevelId, qualifications } =
            detail;
          const translatedBoatType = t(
            translationConstants[boatTypeEnumReversed[boatTypeId]]
          );
          const translatedLevel = t(
            translationConstants[levelEnumReversed[levelId]]
          );
          const translatedProficiencyLevel = t(
            translationConstants[
              proficiencyLevelEnumReversed[proficiencyLevelId]
            ]
          );

          return (
            <div
              className="my-4 px-2 profile-sidebar-margin"
              key={`document-${docIndex}-detail-${detailIndex}`}
            >
              <CertificateDetailRow
                heading={t(translationConstants.BOAT_TYPE)}
                content={translatedBoatType}
              />
              <CertificateDetailRow
                heading={t(translationConstants.LEVEL)}
                content={translatedLevel}
              />
              {translatedProficiencyLevel && (
                <CertificateDetailRow
                  heading={t(translationConstants.PROFICIENCY_LEVEL)}
                  content={translatedProficiencyLevel}
                />
              )}
              {qualifications?.map((file, fileIndex) => (
                <div
                  className="digital-certitficate-link"
                  key={`file-${fileIndex}`}
                >
                  <a href={file?.link} target="_blank" rel="noreferrer">
                    {t(translationConstants.DOWNLOAD_ENDORSEMENT_LETTER)}
                  </a>
                  <br />
                </div>
              ))}
            </div>
          );
        });
      })}

      {props.isInstructorTab &&
        (profileData?.userInfo?.role === roles.FreelanceInstructor ? (
          <>
            <p className="border-top" />
            <div className="py-3 px-2 profile-sidebar-margin">
              <div className="pe-1">
                <h6 className="verify-doc w-100 d-flex justify-content-between align-items-center">
                  <Col>
                    <h6 className="font-14 fw-700 text-decoration-underline m-0">
                      {t(translationConstants.FREELANCE_INSTRUCTOR)}{" "}
                    </h6>
                  </Col>
                  <Col className="d-flex justify-content-center">
                    <div className="pill-width">
                      <span className="font-12 px-2">
                        {t(translationConstants.Update)}
                      </span>
                      <img
                        className="cursor-pointer"
                        src={editIcon}
                        alt="update freelance"
                        onClick={() => {
                          setFreelanceModal(true);
                        }}
                      />
                    </div>
                  </Col>
                </h6>
              </div>
              <div className="">
                <h6 className="verify-doc w-100 d-flex justify-content-between align-items-center">
                  <Col>
                    <h6 className="font-14 fw-700 m-0">
                      {t(translationConstants.TEACHING_LOCATION)}{" "}
                    </h6>
                  </Col>
                </h6>
              </div>
              <div className="font-14">
                {direction === Directions.rtl && freelanceData?.spotArabicName
                  ? freelanceData?.spotArabicName
                  : freelanceData?.spotName}
              </div>
              <div className="pt-3">
                <h6 className="verify-doc w-100 d-flex justify-content-between align-items-center">
                  <Col>
                    <h6 className="font-14 fw-700 m-0">
                      {t(translationConstants.SPORTS_OFFERED_WITH_BRACKETS)}
                    </h6>
                  </Col>
                </h6>
              </div>
              <div>{getSportNames(freelanceData?.sportIds)}</div>
            </div>
          </>
        ) : profileData?.instructorCenterId ? (
          <>
            <p className="border-top" />
            <div className="py-3 px-2 profile-sidebar-margin">
              <h6 className="verify-doc w-100 d-flex justify-content-start align-items-center">
                <Col>
                  <h6 className="font-14 fw-700 m-0">
                    {t(translationConstants.Affiliated_Center)}
                  </h6>
                </Col>
              </h6>
              <div className="font-14 pt-2">
                {direction === Directions.rtl &&
                instructorData?.centerArabicName
                  ? instructorData?.centerArabicName
                  : instructorData?.centerName}
              </div>
            </div>
          </>
        ) : (
          ""
        ))}

      {props.isInstructorTab && isFreelanceModal && (
        <FreelanceAddonModal
          isShow={isFreelanceModal}
          setShow={setFreelanceModal}
          isFreelanceAddon={true}
        />
      )}
    </div>
  );
};

export default GeneralTabSideView;
